import FaultSearchBar from './FaultSearchBar';

export default FaultSearchBar;
